import { useFlags } from "launchdarkly-react-client-sdk";

import NotFound from "pages/NotFound";

interface Props {
  flags: string[];
  children: React.ReactNode;
}

const FeatureFlaggedComponent = ({ flags, children }: Props) => {
  const ldFeatureFlags = useFlags();

  return flags.every((flag) => ldFeatureFlags[flag]) ? children : <NotFound />;
};

export default FeatureFlaggedComponent;
